import { createStyles, makeStyles } from '@material-ui/core';
import React from 'react';
import { InfoCircleIcon } from '../Icons';
const useStyles = makeStyles((theme) => createStyles({
    root: {
        color: theme.palette.primary.main,
        fontSize: 12,
        fontFamily: 'Roboto',
        fontWeight: 500,
        display: 'flex',
        padding: theme.spacing(1),
    },
    icon: {
        width: theme.spacing(2),
        height: theme.spacing(2),
        marginRight: `${theme.spacing(0.5)}px`,
    },
    text: {
        marginTop: '6px',
    },
}));
const HelperText = ({ text, children }) => {
    const classes = useStyles();
    return (React.createElement("div", { className: classes.root },
        React.createElement(InfoCircleIcon, { style: { fontSize: 24, marginRight: 8 } }),
        React.createElement("div", { className: classes.text }, children || text)));
};
export default HelperText;
//# sourceMappingURL=HelperText.js.map